export default __webpack_public_path__ + "static/media/airbnb.ccb680f1.png";